import React, { useState } from "react";
import { Box, TextField, Button, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../redux/store";
import { sendResetEmail } from "../redux/authSlice";
import { useNavigate } from "react-router-dom";

const ResetPassword: React.FC = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { status } = useSelector((state: RootState) => state.auth);

  const handleReset = async () => {
    setError("");
    setMessage("");
    if (!email) {
      setError("Please enter your email");
      return;
    }
    try {
      await dispatch(sendResetEmail(email)).unwrap();
      setMessage("Password reset email has been sent ✅");
    } catch (err: any) {
      setError(err.message || "Failed to send reset email");
    }
  };

  return (
    <Box
      sx={{
        position: "relative",
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "linear-gradient(135deg,#ffffff,#e0e0e0,#c0c0c0)", // silver/white background
        p: 2,
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: 440,
          background: "rgba(255,255,255,0.95)",
          borderRadius: 4,
          p: 4,
          boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
        }}
      >
        {/* Title */}
        <Typography
          variant="h5"
          fontWeight={700}
          textAlign="center"
          mb={3}
          color="#0b4bb8ff"
        >
          Reset Your Password
        </Typography>

        {/* Email Field */}
        <TextField
          label="Email Address"
          placeholder="Enter your registered email"
          fullWidth
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          sx={{ mb: 3 }}
        />

        {/* Error / Success */}
        {error && (
          <Typography color="error" fontSize={13} textAlign="center" mb={2}>
            {error}
          </Typography>
        )}
        {message && (
          <Typography color="green" fontSize={13} textAlign="center" mb={2}>
            {message}
          </Typography>
        )}

        {/* Reset Button */}
        <Button
          fullWidth
          onClick={handleReset}
          disabled={status === "loading"}
          sx={{
            py: 1.5,
            fontWeight: 600,
            borderRadius: 2,
            background: "linear-gradient(90deg, #ffffff, #0073ffff)", // white to gold
            color: "#000",
            boxShadow: "0 6px 18px rgba(11, 147, 184, 0.35)",
            "&:hover": {
              background: "linear-gradient(90deg , #f5f5f5, #209cdaff )",
            },
            mb: 2,
          }}
        >
          {status === "loading" ? "Sending..." : "Send Reset Link"}
        </Button>

        {/* Back to Login */}
        <Typography sx={{ textAlign: "center", fontSize: 13 }}>
          Remember your password?{" "}
          <span
            style={{ cursor: "pointer", color: "#0b4db8ff" }}
            onClick={() => navigate("/AuthSwitch")}
          >
            Login
          </span>
        </Typography>
      </Box>
    </Box>
  );
};

export default ResetPassword;
